import React, { useState } from "react";

import DBListItem from "../../common/db-list/DBListItem";

import SonicTeam from "../../common/classes/SonicTeam";
import ArchiveWrapper from "../../common/archive/ArchiveWrapper";
import AdvancedSearchTeam from "./AdvancedSearchTeam";
import { SearchParam } from "../../common/archive/ListSearchFunc";
import PageTitle from "../../common/PageTitle";
import PageHelperModal from "../../common/page-help/PageHelperModal";

type Props = {
  keywordParam: string;
  teams: Array<SonicTeam>;
  isLoading: boolean;
  perView: number;
  totalPage: number;
  currentPage: number;
  totalEntries: number;
  handlePerView: (value: number) => void;
  searchHandler: (params: Array<SearchParam>) => void;
  clearSearch: () => void;
  gameParams: Array<string>;
  gameOptions: Array<string>;
};

const TeamDB: React.FC<Props> = ({
  keywordParam,
  teams,
  isLoading,
  perView,
  totalPage,
  currentPage,
  totalEntries,
  handlePerView,
  searchHandler,
  clearSearch,
  gameParams,
  gameOptions,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleHelpModal = () => {
    setShowModal(!showModal);
  };

  return (
    <main>
      <PageTitle
        title={"TEAM"}
        subtext={"チーム"}
        handleHelpModal={handleHelpModal}
      />
      <ArchiveWrapper
        title={"チーム一覧"}
        hasResults={teams.length == 0 ? false : true}
        isLoading={isLoading}
        currentPage={currentPage}
        perView={perView}
        totalEntries={totalEntries}
        totalPages={totalPage}
        handlePerView={handlePerView}
        searchComponent={
          <>
            <AdvancedSearchTeam
              keywordParam={keywordParam}
              gameParams={gameParams}
              gameOptions={gameOptions}
              clearSearch={clearSearch}
              searchHandler={searchHandler}
            />
          </>
        }
      >
        {teams?.map((team, i: number) => (
          <DBListItem
            to={`/team/${team.id}`}
            key={i}
            img_src={
              team.term !== null ? team.term.img?.thumbnail.url : undefined
            }
            team_color={team.term !== null ? team.term.color : undefined}
            {...team}
          />
        ))}
      </ArchiveWrapper>
      {showModal === true ? (
        <PageHelperModal
          handleHelpModal={handleHelpModal}
          helpTitle="チームとは？"
          helpText={
            "SELeCT会員のチームが掲載されています。\nチームメンバーやチームのSNSが閲覧できます。"
          }
        />
      ) : null}
    </main>
  );
};

export default TeamDB;
